import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { APTContext } from "src/app/services/aptContext/apt-context";
import { waitForEngagementDetailsFetched } from "src/standard/guards/can-match/waitForEngagementDetailsFetched";
import { ModalDialogService } from "src/standard/standard-modal-button/showModalDialog";

export const EngagementDetailsTimeoutGuard: CanMatchFn = async () => {
  const aptContext = inject(APTContext);
  const modalDialogService = inject(ModalDialogService);
  try {
    await waitForEngagementDetailsFetched(aptContext);

    // not timed out, so return false
    return false;
  } catch (error) {
    if (error instanceof Error && error.message.includes("Timeout")) {
      const shouldRefresh = await modalDialogService.showConfirmationDialog({
        variant: "refresh",
        title: $localize`Request timed out`,
        message: $localize`The request has timed out. Click Refresh to reload the page. If you receive this message repeatedly and your action is unsuccessful after retry, contact support for assistance.`,
        confirmText: $localize`Refresh`,
      });

      if (shouldRefresh) {
        window.location.reload();
      }

      // timed out, so match
      return true;
    }

    // other error, not relevant here
    // rethrow so it can be handled elsewhere
    // eg in the case of 401, we want that handler
    // to handle it and refresh the token
    throw error;
  }
};
